import { render } from "./Calculations.vue?vue&type=template&id=9e28f2aa&scoped=true"
import script from "./Calculations.vue?vue&type=script&lang=js"
export * from "./Calculations.vue?vue&type=script&lang=js"

import "./Calculations.vue?vue&type=style&index=0&id=9e28f2aa&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e28f2aa"]])

export default __exports__